import React from "react";
import { FaShieldAlt, FaNetworkWired } from "react-icons/fa";
import { AiTwotoneAppstore } from "react-icons/ai";
import { BiCodeAlt } from "react-icons/bi";

export const services = [
  {
    icon: <FaNetworkWired />,
    title: "Network Engineering & Infrastructure",
    subTitle:
      "Design and deployment of fiber optic and backbone network infrastructure, from planning through execution, for enterprise-scale telecommunications.",
  },
  {
    icon: <BiCodeAlt />,
    title: "Full Stack Development",
    subTitle:
      "Develop modern web and mobile applications. Expertise in building scalable, maintainable, and user-friendly systems.",
  },
  {
    icon: <FaShieldAlt />,
    title: "Network Security",
    subTitle:
      "Published research on federated learning for intrusion detection. Skilled in identifying vulnerabilities, mitigating risks, and protecting sensitive data.",
  },
  {
    icon: <AiTwotoneAppstore />,
    title: "Cloud & Automation",
    subTitle:
      "AWS and Azure deployments, Docker and Kubernetes, CI/CD pipelines, and automation scripting supporting network provisioning and service delivery.",
  },
];
